import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map, share } from 'rxjs/operators';
import { environment } from '~environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConfigValuesService {
  private configs$$ = new BehaviorSubject<Record<string, any>>(null);

  get configs$(): Observable<Record<string, any>> {
    return this.configs$$.asObservable().pipe(
      filter((configs) => !!configs),
      map((configs) => Object.assign({}, configs)),
      share(),
    );
  }

  constructor(private db: AngularFirestore) {
    this.subscribeToConfigVals();
  }

  private subscribeToConfigVals() {
    this.db
      .doc<Record<string, any>>(`hauli-config-values/${environment.environment}`)
      .valueChanges()
      .subscribe(
        (configs) => {
          if (configs) {
            this.configs$$.next(configs);
          } else {
            this.configs$$.next({});
          }
        },
        (error) => {
          this.configs$$.next({});
        },
      );
  }
}
